var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208.01 66.84",
    style: {
      enableBackground: "new 0 0 208.01 66.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    transform: "translate(145.691 19.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    d: "M27.69,13.49c-0.61-3.07-3.33-4.03-7.27-4.03c-3.77,0-6.57,1.14-6.57,3.85c0,2.45,1.75,3.07,4.82,3.68 l8.15,1.23c8.5,1.31,14.37,5.43,14.37,14.46c0,7.53-6.74,14.63-19.98,14.63C7.54,47.31,0.97,41.36,0,31.98h12.18 c0.61,4.12,3.77,5.87,8.94,5.87c4.91,0,7.8-1.67,7.8-4.91c0-3.07-2.02-4.2-6.48-4.99l-8.76-1.4 c-7.1-1.31-12.09-4.73-12.09-12.44S7.45,0,20.77,0c11.3,0,18.14,5.43,19.1,13.49L27.69,13.49z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    width: 12.35,
    height: 65.68
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 200.65,
    cy: 59.47,
    r: 7.36
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    d: "M140.3,40.89c-0.27-12.26-8.06-21.37-21.73-21.37c-13.93,0-22.7,9.11-22.7,23.48s8.67,23.83,22.96,23.83 c14.12,0,19.76-7.68,21.11-15.34h-12.38c-0.77,2.52-2.75,5.17-8.55,5.17c-6.93,0-10.52-4.29-10.94-11.84h32.24L140.3,40.89 L140.3,40.89z M108.4,36.86c0.68-3.33,2.89-8.14,10.08-8.14c6.44,0,8.91,4.16,9.34,8.14H108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    d: "M24.53,32.61h10.45c3.94,0,7.13-3.19,7.13-7.13c0,0,0,0,0,0v-4.83h-12.5l-6.91,9l-5.97,7.78 c-1.32,1.73-1.45,4.09-0.31,5.94L30.1,65.69h14.69L24.53,32.61z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4294",
    d: "M68.27,19.51c-10.87,0-18.93,5.34-19.19,14.02h12.18c0.35-3.07,2.72-4.82,7.62-4.82 c5.34,0,7.97,2.37,7.97,7.01v1.14h-12c-13.32,0-18.31,7.97-18.31,14.98c0,7.97,5.78,14.98,15.95,14.98l0,0 c7.1,0,12.56-3.06,14.9-7.94v6.8h11.3V36.42C88.68,24.33,80.44,19.51,68.27,19.51z M58.8,50.88c0-4.12,3.15-6.05,8.41-6.05h9.64 v2.8c0,5.61-4.12,9.46-10.08,9.46C61.78,57.1,58.8,55,58.8,50.88L58.8,50.88z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f26247c3ab2592af2d65037c23cb13c.svg";
export { ForwardRef as ReactComponent };